/**
 * Session storage keys used throughout the application.
 * Centralized to avoid typos and make it easier to maintain.
 */
export const SESSION_STORAGE_KEYS = {
  /**
   * Key for storing the workflow preview display preference (desktop/mobile)
   * Used in WorkflowEditor and LauncherPreview components
   */
  WORKFLOW_PREVIEW_DISPLAY: 'workflow-preview-display',
  /**
   * One-shot marker set when a spoof session ends outside React (a 401 that could not be
   * recovered). Read and cleared by CompanyListing to explain the redirect, since the
   * redirect is a full page load and a toast fired before it would never paint.
   */
  SPOOF_SESSION_ENDED_NOTICE: 'spoof-session-ended-notice',
} as const;
